import { AxisValue, DashBoardCondition } from "features/dashBoard/types"
import { filterCompare } from "features/dashBoard/util"
import { numberFormat, round } from "shared/util"

export {
  type AxisValue,
  type GraphType,
  type GraphDefaultProps,
  type GraphOptions,
  type GraphActions
} from '../../../types'
export {
  filter,
  filterCompare,
  getAxisDef,
  getValueDef
} from '../../../util'

export { GraphRender } from '../components/graphRender'

export type CommonGraphStyle = {
  shadowBlur?: number
  shadowOffsetX?: number
  shadowOffsetY?: number
  shadowColor?: string
  opacity?: number
  color?: string
}
const SelectedItemStyle = {
  shadowBlur: 10,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  shadowColor: 'rgba(0,0,0,0.5)'
}
const NotSelectedItemStyle = {
  opacity: 0.3
}
const SelectedAreaStyle = undefined
const NotSelectedAreaStyle = {
  color: 'rgb(200,200,200)'
}

export const selectedItemStyle = (condition: DashBoardCondition | undefined, axis: AxisValue) => {
  if (!condition) return undefined
  if (filterCompare(condition, axis)) return SelectedItemStyle
  return NotSelectedItemStyle
}
export const selectedAreaStyle = (condition: DashBoardCondition | undefined, axis: AxisValue) => {
  if (!condition) return undefined
  if (filterCompare(condition, axis)) return SelectedAreaStyle
  return NotSelectedAreaStyle
}

export const numericValueFormat = (
  value: number | string | undefined | null,
  digit: number,
  unit: string | undefined | null
) => {
  if (value === undefined || value === null || value === '') return '-'
  if (typeof value === 'number') {
    return numberFormat(round(value, digit)) + (unit ? (' ' + unit) : '')
  }
  return value + (unit ? (' ' + unit) : '')
}
export const percentFormat = (
  name: string | undefined | null,
  percent: number | undefined | null,
  digit: number
) => {
  if (name) {
    return `${name}\n${percent ? round(percent, digit) : '-'}%`
  } else {
    return `${percent ? round(percent, digit) : '-'}%`
  }
}
